<template>
  <div v-if="visible" class="plate-keyboard-overlay" @click.self="handleClose">
    <div class="plate-keyboard" @click.stop>
      <div class="keyboard-header">
        <span class="keyboard-title">
          <span v-if="currentValue">{{ currentValue }}</span>
          <span v-else>{{ keyboardTitle }}</span>
        </span>
        <span class="keyboard-close" @click="handleClose">关闭</span>
      </div>
      
      <!-- 省份简称键盘 -->
      <div v-if="showProvinceKeyboard" class="keyboard-grid">
        <div class="keyboard-row">
          <button class="keyboard-key" @click="selectProvince('京')">京</button>
          <button class="keyboard-key" @click="selectProvince('津')">津</button>
          <button class="keyboard-key" @click="selectProvince('沪')">沪</button>
          <button class="keyboard-key" @click="selectProvince('冀')">冀</button>
          <button class="keyboard-key" @click="selectProvince('豫')">豫</button>
          <button class="keyboard-key" @click="selectProvince('云')">云</button>
          <button class="keyboard-key" @click="selectProvince('辽')">辽</button>
          <button class="keyboard-key" @click="selectProvince('黑')">黑</button>
          <button class="keyboard-key" @click="selectProvince('湘')">湘</button>
        </div>
        <div class="keyboard-row">
          <button class="keyboard-key" @click="selectProvince('皖')">皖</button>
          <button class="keyboard-key" @click="selectProvince('鲁')">鲁</button>
          <button class="keyboard-key" @click="selectProvince('新')">新</button>
          <button class="keyboard-key" @click="selectProvince('苏')">苏</button>
          <button class="keyboard-key" @click="selectProvince('浙')">浙</button>
          <button class="keyboard-key" @click="selectProvince('赣')">赣</button>
          <button class="keyboard-key" @click="selectProvince('鄂')">鄂</button>
          <button class="keyboard-key" @click="selectProvince('桂')">桂</button>
          <button class="keyboard-key" @click="selectProvince('甘')">甘</button>
        </div>
        <div class="keyboard-row">
          <button class="keyboard-key" @click="selectProvince('晋')">晋</button>
          <button class="keyboard-key" @click="selectProvince('蒙')">蒙</button>
          <button class="keyboard-key" @click="selectProvince('陕')">陕</button>
          <button class="keyboard-key" @click="selectProvince('吉')">吉</button>
          <button class="keyboard-key" @click="selectProvince('闽')">闽</button>
          <button class="keyboard-key" @click="selectProvince('贵')">贵</button>
          <button class="keyboard-key" @click="selectProvince('粤')">粤</button>
          <button class="keyboard-key" @click="selectProvince('川')">川</button>
          <button class="keyboard-key" @click="selectProvince('青')">青</button>
        </div>
        <div class="keyboard-row">
          <button class="keyboard-key" @click="selectProvince('藏')">藏</button>
          <button class="keyboard-key" @click="selectProvince('琼')">琼</button>
          <button class="keyboard-key" @click="selectProvince('渝')">渝</button>
          <button class="keyboard-key" @click="selectProvince('宁')">宁</button>
          <button class="keyboard-key" @click="selectProvince('学')">学</button>
          <button class="keyboard-key" @click="selectProvince('港')">港</button>
          <button class="keyboard-key" @click="selectProvince('澳')">澳</button>
        </div>
      </div>
      
      <!-- 字母数字键盘 -->
      <div v-if="showAlphanumericKeyboard" class="keyboard-grid">
        <div class="keyboard-row">
          <button 
            class="keyboard-key" 
            :class="{ 'keyboard-key-disabled': isNumberDisabled }"
            :disabled="isNumberDisabled"
            @click="inputCharacter('1')">1</button>
          <button 
            class="keyboard-key" 
            :class="{ 'keyboard-key-disabled': isNumberDisabled }"
            :disabled="isNumberDisabled"
            @click="inputCharacter('2')">2</button>
          <button 
            class="keyboard-key" 
            :class="{ 'keyboard-key-disabled': isNumberDisabled }"
            :disabled="isNumberDisabled"
            @click="inputCharacter('3')">3</button>
          <button 
            class="keyboard-key" 
            :class="{ 'keyboard-key-disabled': isNumberDisabled }"
            :disabled="isNumberDisabled"
            @click="inputCharacter('4')">4</button>
          <button 
            class="keyboard-key" 
            :class="{ 'keyboard-key-disabled': isNumberDisabled }"
            :disabled="isNumberDisabled"
            @click="inputCharacter('5')">5</button>
          <button 
            class="keyboard-key" 
            :class="{ 'keyboard-key-disabled': isNumberDisabled }"
            :disabled="isNumberDisabled"
            @click="inputCharacter('6')">6</button>
          <button 
            class="keyboard-key" 
            :class="{ 'keyboard-key-disabled': isNumberDisabled }"
            :disabled="isNumberDisabled"
            @click="inputCharacter('7')">7</button>
          <button 
            class="keyboard-key" 
            :class="{ 'keyboard-key-disabled': isNumberDisabled }"
            :disabled="isNumberDisabled"
            @click="inputCharacter('8')">8</button>
          <button 
            class="keyboard-key" 
            :class="{ 'keyboard-key-disabled': isNumberDisabled }"
            :disabled="isNumberDisabled"
            @click="inputCharacter('9')">9</button>
          <button 
            class="keyboard-key" 
            :class="{ 'keyboard-key-disabled': isNumberDisabled }"
            :disabled="isNumberDisabled"
            @click="inputCharacter('0')">0</button>
        </div>
        <div class="keyboard-row">
          <button class="keyboard-key" @click="inputCharacter('A')">A</button>
          <button class="keyboard-key" @click="inputCharacter('B')">B</button>
          <button class="keyboard-key" @click="inputCharacter('C')">C</button>
          <button class="keyboard-key" @click="inputCharacter('D')">D</button>
          <button class="keyboard-key" @click="inputCharacter('E')">E</button>
          <button class="keyboard-key" @click="inputCharacter('F')">F</button>
          <button class="keyboard-key" @click="inputCharacter('G')">G</button>
          <button class="keyboard-key" @click="inputCharacter('H')">H</button>
          <button class="keyboard-key" @click="inputCharacter('J')">J</button>
          <button class="keyboard-key" @click="inputCharacter('K')">K</button>
        </div>
        <div class="keyboard-row">
          <button class="keyboard-key" @click="inputCharacter('L')">L</button>
          <button class="keyboard-key" @click="inputCharacter('M')">M</button>
          <button class="keyboard-key" @click="inputCharacter('N')">N</button>
          <button class="keyboard-key" @click="inputCharacter('P')">P</button>
          <button class="keyboard-key" @click="inputCharacter('Q')">Q</button>
          <button class="keyboard-key" @click="inputCharacter('R')">R</button>
          <button class="keyboard-key" @click="inputCharacter('S')">S</button>
          <button class="keyboard-key" @click="inputCharacter('T')">T</button>
          <button class="keyboard-key" @click="inputCharacter('U')">U</button>
          <button class="keyboard-key" @click="inputCharacter('V')">V</button>
        </div>
        <div class="keyboard-row">
          <button class="keyboard-key" @click="inputCharacter('W')">W</button>
          <button class="keyboard-key" @click="inputCharacter('X')">X</button>
          <button class="keyboard-key" @click="inputCharacter('Y')">Y</button>
          <button class="keyboard-key" @click="inputCharacter('Z')">Z</button>
          <button class="keyboard-key keyboard-backspace" @click="backspaceCharacter()">⌫</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlateKeyboard',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 8
    }
  },
  data () {
    return {
      showProvinceKeyboard: true,
      showAlphanumericKeyboard: false,
      currentValue: ''
    }
  },
  computed: {
    keyboardTitle () {
      return this.showProvinceKeyboard ? '选择省份简称' : '输入车牌号码'
    },
    // 判断是否应该禁用数字键（第二位只能输入字母）
    isNumberDisabled () {
      return this.currentValue.length === 1
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        this.currentValue = this.value || ''
        // 根据当前值决定显示哪个键盘
        if (this.currentValue.length === 0) {
          this.showProvinceKeyboard = true
          this.showAlphanumericKeyboard = false
        } else {
          this.showProvinceKeyboard = false
          this.showAlphanumericKeyboard = true
        }
      }
    },
    value (newVal) {
      this.currentValue = newVal || ''
    }
  },
  methods: {
    handleClose () {
      // 重置键盘状态
      if (this.currentValue.length === 0) {
        this.showProvinceKeyboard = true
        this.showAlphanumericKeyboard = false
      }
      this.$emit('close')
    },
    selectProvince (province) {
      this.currentValue = province
      this.showProvinceKeyboard = false
      this.showAlphanumericKeyboard = true
      this.$emit('input', this.currentValue)
    },
    inputCharacter (char) {
      if (this.currentValue.length >= this.maxLength) {
        return
      }
      // 第二位（索引1）只能输入字母，不能输入数字
      if (this.currentValue.length === 1 && /[0-9]/.test(char)) {
        return
      }
      this.currentValue += char
      this.$emit('input', this.currentValue)
    },
    backspaceCharacter () {
      if (this.currentValue.length > 0) {
        this.currentValue = this.currentValue.slice(0, -1)
        // 如果删除到空，切换回省份键盘
        if (this.currentValue.length === 0) {
          this.showProvinceKeyboard = true
          this.showAlphanumericKeyboard = false
        }
        this.$emit('input', this.currentValue)
      }
    }
  }
}
</script>

<style scoped>
.plate-keyboard-overlay {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 430px;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10000;
  display: flex;
  align-items: flex-end;
}

.plate-keyboard {
  width: 100%;
  background: #f7f8fa;
  border-top: 1px solid #e0e0e0;
  animation: slideUp 0.3s ease-out;
  max-height: 70vh;
  overflow-y: auto;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.keyboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
}

.keyboard-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.keyboard-close {
  color: #3572e6;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.keyboard-close:hover {
  background: #f0f0f0;
}

.keyboard-grid {
  padding: 12px;
  max-width: 100%;
  box-sizing: border-box;
}

.keyboard-row {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
  justify-content: center;
  flex-wrap: nowrap;
}

.keyboard-row:last-child {
  margin-bottom: 0;
}

.keyboard-key {
  flex: 1;
  min-width: 0;
  max-width: 40px;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 1;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.keyboard-key:hover {
  background: #f0f0f0;
  border-color: #ccc;
}

.keyboard-key:active {
  transform: scale(0.95);
  background: #e0e0e0;
}

.keyboard-backspace {
  flex: 1.5;
  min-width: 0;
  max-width: 60px;
  font-size: 18px;
  color: #666;
}

.keyboard-key-disabled {
  background: #f5f5f5 !important;
  color: #bbb !important;
  border-color: #e0e0e0 !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

.keyboard-key-disabled:hover {
  background: #f5f5f5 !important;
  border-color: #e0e0e0 !important;
}

.keyboard-key-disabled:active {
  transform: none !important;
  background: #f5f5f5 !important;
}

/* 移动端优化 */
@media (max-width: 430px) {
  .keyboard-key {
    max-width: 36px;
    height: 36px;
    font-size: 14px;
  }
  
  .keyboard-backspace {
    max-width: 54px;
  }
  
  .keyboard-grid {
    padding: 8px;
  }
  
  .keyboard-row {
    gap: 4px;
    margin-bottom: 6px;
  }
}
</style>

